import script from "./wisdom.vue?vue&type=script&setup=true&lang=js"
export * from "./wisdom.vue?vue&type=script&setup=true&lang=js"

import "./wisdom.vue?vue&type=style&index=0&id=79ab825c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ab825c"]])

export default __exports__